import { render } from "./tabProjects.vue?vue&type=template&id=530c35a3"
import script from "./tabProjects.vue?vue&type=script&lang=js"
export * from "./tabProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__